import { useQuery, useQueryClient } from '@tanstack/react-query';
import apiFetch from '../../utils/apiFetch';
import { authHeaders } from './helpers';
import type { Employee } from './types';

export function useEmployee(id: string | undefined) {
  const queryClient = useQueryClient();

  const query = useQuery<Employee, Error>({
    queryKey: ['employee', id],
    enabled: Boolean(id),
    queryFn: async () => {
      const r = await apiFetch('/api/v1/payroll/employees/' + id, { headers: authHeaders() });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const data = await r.json();
      return (data.employee || data) as Employee;
    },
  });

  const setEmployee = (newData: Employee): void => {
    queryClient.setQueryData(['employee', id], newData);
  };

  const invalidateEmployee = (): void => {
    queryClient.invalidateQueries({ queryKey: ['employee', id] });
  };

  return {
    employee: query.data,
    isLoading: query.isLoading,
    error: query.error,
    setEmployee,
    invalidateEmployee,
    queryClient,
  };
}